import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { RotateCcw, Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export const SetupCard = ({ space = "personal" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: p } = useQuery({ queryKey: ["setup", space], queryFn: () => api.get(`/setup/${space}`).then((r) => r.data) });
  const open = () => navigate(`/configuration?space=${space}`);

  useEffect(() => {
    if (p && !p.started && user.is_demo && !user.read_only && !user.sandbox) { navigate(`/configuration?space=${space}`); }
  }, [p, user, space, navigate]);

  if (!p || user.read_only || user.sandbox) return null;
  const restart = async () => { await api.post(`/setup/${space}/reset`); qc.invalidateQueries({ queryKey: ["setup", space] }); open(); };
  const pct = Math.round((p.count / p.total) * 100);
  return (
    <section className="card-surface flex flex-wrap items-center gap-4 p-4" data-testid={`setup-card-${space}`}>
      <span className="tone-chip tone-mint flex h-10 w-10 shrink-0 items-center justify-center rounded-xl"><Settings2 className="h-5 w-5" /></span>
      <div className="min-w-0 flex-1 basis-48">
        <div className="font-bold" data-testid={`setup-card-count-${space}`}>Configuration {p.count}/{p.total}</div>
        <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-secondary"><div className="h-full rounded-full bg-sage transition-all" style={{ width: `${pct}%` }} /></div>
      </div>
      {p.done
        ? <Button variant="outline" size="sm" className="rounded-full" onClick={restart} data-testid={`setup-restart-${space}`}><RotateCcw className="mr-1 h-3.5 w-3.5" />Recommencer la configuration</Button>
        : <Button size="sm" className="rounded-full" onClick={open} data-testid={`setup-resume-${space}`}>{p.count ? "Reprendre" : "Commencer"}</Button>}
    </section>
  );
};
